import React, {useState} from "react";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AboutIntro from '../components/AboutIntro';
import AboutListing from '../components/AboutListing';
import styled from "styled-components";
import AOS from 'aos';
import 'aos/dist/aos.css';

const StyledAboutSection = styled.section`
    padding: 22px 16px;

    &.first {
        padding: 44px 16px 22px 16px;
    }

    &.last {
        padding: 22px 16px 44px 16px;
    }

    @media (min-width: 768px) {
        padding: 36px 24px;

        &.first {
            padding: 72px 24px 36px 24px;
        }

        &.last {
            padding: 36px 24px 72px 24px;
        }
    }

    .about-listing-container {
        display: flex;
        row-gap: 36px;

        @media (min-width: 768px) {
            row-gap: 64px;
        }
    }
`;

const StyledImgContainer = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    row-gap: 24px;

    div.about-image {

        img {
            width: 100%;
            aspect-ratio: 5 / 4;
            border-radius: 8px;
            max-width: 400px;

            @media (min-width: 768px) {
                width: 100%;
                height: 200px;
                object-fit: cover;
            }

            @media (min-width: 860px) {
                height: 300px;
            }
        }

        @media (min-width: 768px) {
            max-width: 100%;
            flex: 1;
        }

        p {
            margin: 8px 0 0 0;
            width: 100%;
            max-width: 400px;

            a {
                color: ${palette.neutral11};
                font-weight: 400;
                text-underline-offset: 4px;

                &:hover, &:focus-visible {
                    color: ${palette.pinkMain};
                }

                &:focus-visible {
                    outline: 3px solid ${palette.blueMain};
                    outline-offset: 3px;
                    border-radius: 2px;
                }
            }
        }
    }

    @media (min-width: 768px) {
        flex-flow: row nowrap;
        column-gap: 24px;
        row-gap: 0;
    }
`;

const About = () => {

    AOS.init();
    return (
        <main>
            <StyledAboutSection>
                <AboutIntro></AboutIntro>
            </StyledAboutSection>
            <StyledAboutSection className={"last"}>
                <Container>
                    <Row className={"about-listing-container"}>
                        <Col xs={12} lg={4}>
                            <AboutListing
                                className={"left"}
                                title={"Design approach"}
                                description={"No matter the project, I always keep these principles in mind:"}
                                list={
                                    <ul>
                                        <li>Prioritize accessibility and inclusion</li>
                                        <li>Focus on clarity and ease of use</li>
                                        <li>Let research guide design decisions</li>
                                        <li>Iterate based on user feedback</li>
                                        <li>Balance user needs with business goals</li>
                                    </ul>
                                }>
                            </AboutListing>
                        </Col>
                        <Col xs={12} lg={4}>
                            <AboutListing
                                className={"middle"}
                                title={"UX skills"}
                                description={"These skills help me turn user needs into clear, accessible, and effective design solutions:"}
                                list={
                                    <ul>
                                        <li>Wireframes</li>
                                        <li>Prototyping</li>
                                        <li>Usability testing</li>
                                        <li>Interaction design</li>
                                        <li>UX research</li>
                                        <li>User flows</li>
                                        <li>Web accessibility testing</li>
                                        <li>Artificial intelligence</li>
                                    </ul>
                                }>
                            </AboutListing>
                        </Col>
                        <Col xs={12} lg={4}>
                            <AboutListing
                                className={"right"}
                                title={"Tools"}
                                description={"Here’s how I bring my ideas to life:"}
                                list={
                                    <ul>
                                        <li><span className={"semibold"}>UI/UX:</span> Figma, Axure RP, Miro</li>
                                        <li><span className={"semibold"}>Visual design:</span> Adobe Creative Suite</li>
                                        <li><span className={"semibold"}>Accessibility:</span> axe DevTools, WAVE, Lighthouse, VoiceOver, manual testing</li>
                                        <li><span className={"semibold"}>Front-end development:</span> HTML/CSS, Bootstrap, JavaScript, Lottie</li>
                                    </ul>
                                }>
                            </AboutListing>
                        </Col>
                    </Row>
                </Container>
            </StyledAboutSection>
        </main>
    )
}

export default About;